import styled from '@emotion/styled';
import { m } from 'framer-motion';
import { indicateScrollFade } from '~/shared/utils/styled';
import { ifProp } from 'styled-tools';

export const storeFadeIndicatorHeight = 40;

export const StyledReservationResults = styled(m.div, {
    shouldForwardProp: (prop: string) => prop !== 'hasResults',
})<{ hasResults: boolean }>(
    {
        overflow: 'hidden',
    },
    ifProp('hasResults', ({ theme }) => ({
        position: 'relative',
        ...indicateScrollFade({
            height: storeFadeIndicatorHeight,
            color: theme.colors.light,
            place: 'both',
        }),
    }))
);
